var _style, _path, _g, _path2, _path3, _path4, _polygon, _path5, _path6, _rect, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwimming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#315CA7;}\n\t.st1{fill:#5CC4EF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#2D9FBF;}\n\t.st4{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.3,182.9c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6S29,63.99,29,106.3 C29,148.6,63.61,182.9,106.3,182.9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "135.75,66.55 76.85,66.55 50.87,142.77 161.73,142.77  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115.83,51.83v2.6H96.77v-2.6h-3.46v39.84h3.46v-2.59h19.05v2.59h3.46V51.83H115.83z M115.83,57.89v6.93H96.77 v-6.93H115.83z M115.83,68.29v6.93H96.77v-6.93H115.83z M96.77,85.61v-6.93h19.05v6.93H96.77z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M84.01,101.25c1.91-1.92,5.03-1.92,6.95,0c1.63,1.63,3.78,2.45,5.93,2.45c2.15,0,4.29-0.82,5.93-2.45 c1.92-1.91,5.04-1.91,6.95,0c3.27,3.27,8.58,3.27,11.85,0c1.92-1.92,5.04-1.91,6.95,0c3.27,3.27,8.59,3.27,11.85,0 c0.68-0.68,0.68-1.77,0-2.45c-0.68-0.68-1.77-0.68-2.45,0c-1.92,1.92-5.04,1.91-6.96,0c-3.27-3.27-8.59-3.27-11.85,0 c-1.92,1.91-5.04,1.91-6.95,0c-3.27-3.27-8.59-3.27-11.85,0c-1.92,1.92-5.04,1.91-6.95,0c-3.27-3.27-8.59-3.27-11.85,0 c-1.92,1.91-5.04,1.91-6.95,0c-0.68-0.68-1.77-0.68-2.45,0c-0.68,0.68-0.68,1.77,0,2.45C75.43,104.52,80.75,104.52,84.01,101.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M73.71,119.6c2.51,0,4.88-0.98,6.66-2.76c2.32-2.32,6.09-2.32,8.42,0c3.67,3.67,9.64,3.67,13.31,0 c2.25-2.25,6.16-2.25,8.42,0c1.78,1.78,4.14,2.76,6.66,2.76c2.51,0,4.88-0.98,6.66-2.76c2.32-2.32,6.09-2.32,8.42,0 c3.67,3.67,9.64,3.67,13.31,0c0.68-0.68,0.68-1.77,0-2.45c-0.68-0.68-1.77-0.68-2.45,0c-2.32,2.32-6.09,2.32-8.42,0 c-3.67-3.67-9.64-3.67-13.31,0c-2.25,2.25-6.16,2.25-8.41,0c-3.67-3.67-9.64-3.67-13.31,0c-2.32,2.32-6.09,2.32-8.41,0 c-3.67-3.67-9.64-3.67-13.31,0c-2.25,2.25-6.17,2.25-8.41,0c-0.68-0.68-1.77-0.68-2.45,0c-0.68,0.68-0.68,1.77,0,2.45 C68.83,118.62,71.19,119.6,73.71,119.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M150.83,129.98c-0.68-0.68-1.77-0.68-2.45,0c-2.74,2.74-7.19,2.74-9.92,0c-1.98-1.98-4.61-3.07-7.41-3.07 s-5.43,1.09-7.41,3.07c-2.74,2.73-7.19,2.73-9.92,0c-1.98-1.98-4.61-3.07-7.41-3.07c-2.8,0-5.43,1.09-7.41,3.07 c-2.74,2.73-7.19,2.73-9.92,0c-1.98-1.98-4.61-3.07-7.41-3.07s-5.43,1.09-7.41,3.07c-2.74,2.74-7.19,2.74-9.92,0 c-0.68-0.68-1.77-0.68-2.45,0c-0.68,0.68-0.68,1.77,0,2.45c4.09,4.09,10.74,4.09,14.82,0c1.33-1.33,3.09-2.06,4.96-2.06 c1.87,0,3.63,0.73,4.96,2.06c4.09,4.09,10.74,4.09,14.82,0c1.33-1.33,3.09-2.06,4.96-2.06c1.87,0,3.63,0.73,4.96,2.06 c4.09,4.09,10.74,4.09,14.82,0c1.33-1.33,3.09-2.06,4.96-2.06s3.63,0.73,4.96,2.06c2.04,2.04,4.73,3.07,7.41,3.07 c2.68,0,5.37-1.02,7.41-3.07C151.51,131.75,151.51,130.66,150.83,129.98z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M117.52,91.49c0-0.04,0-0.08-0.01-0.11C117.52,91.41,117.52,91.45,117.52,91.49L117.52,91.49z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M117.34,89.91L117.34,89.91c0.01,0.08,0.02,0.17,0.04,0.25C117.36,90.08,117.35,90,117.34,89.91z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M116.83,87.87c-0.02-0.07-0.05-0.13-0.07-0.2C116.78,87.74,116.81,87.81,116.83,87.87L116.83,87.87z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "115.55,99.97 115.55,99.97 115.54,99.97 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M117.41,94.56c0,0.02-0.01,0.04-0.01,0.07C117.4,94.6,117.4,94.58,117.41,94.56z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M114.09,102.05L114.09,102.05c-0.27,0.32-0.55,0.65-0.86,0.95C113.54,102.69,113.82,102.37,114.09,102.05z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 114.82,
    y: 101.1,
    className: "st4",
    width: 0,
    height: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M117.11,96.09c-0.01,0.02-0.01,0.04-0.02,0.07C117.1,96.13,117.11,96.11,117.11,96.09z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M117.54,93.03c0,0.01,0,0.02,0,0.03C117.54,93.05,117.54,93.04,117.54,93.03z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwimming);
export default __webpack_public_path__ + "static/media/Swimming.04d9bb8d095182a6671b20a3653cbc82.svg";
export { ForwardRef as ReactComponent };